import { onDutyFree } from '../constants/channels';

const defaultMetaDescription = onDutyFree
  ? 'ELKO í Flugstöð, Keflavíkurflugvelli. Þú getur pantað vörur á síðunni okkar og sótt á leið úr landi, í brottfaraverslun.'
  : 'ELKO - Mesta úrval landsins af raftækjum. Sendum um allt land eða í næstu verslun. Það er einfalt og þægilegt að versla á elko.is.';

export function getMetaTitle({ category }: { category: { seoTitle?: string; name?: string } | undefined }) {
  if (!category) return '';
  return category.seoTitle || category.name || '';
}

export function getMetaDescription(options: {
  searchTermLower?: string;
  category?: { name?: string; seoDescription?: string; descriptionPlaintext?: string };
  shortDescription?: string;
  fallbackPrefix?: string;
}): string {
  // Search page
  if (options.searchTermLower !== undefined) {
    return options.searchTermLower
      ? `„${options.searchTermLower}“ hjá ${defaultMetaDescription}`
      : `Vöruleit hjá ${defaultMetaDescription}`;
  }

  // Category page
  if (options.category) {
    const { name, seoDescription, descriptionPlaintext } = options.category;
    return seoDescription || descriptionPlaintext || `${name} hjá ${defaultMetaDescription}`;
  }

  // Product page (short description)
  if (options.shortDescription) {
    return options.shortDescription;
  }

  // Fallback with prefix or default
  return options.fallbackPrefix ? options.fallbackPrefix + defaultMetaDescription : defaultMetaDescription;
}
